/**
 * Thumbnail stand-in for a model number with no catalogue image (REQ-398).
 *
 * Before this existed the thumbnail slot rendered nothing at all, so imageless
 * rows lost their 48 px column and their text jumped left out of line with the
 * rest of the list. Line-art cabinet, deliberately quiet — it marks the absence
 * of an image, it is not an error state.
 */
export const ModelNumberPlaceholderIcon = ({ className }: { className?: string }) => {
	return (
		<svg
			className={className}
			width="44"
			height="28"
			viewBox="0 0 44 28"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			aria-hidden="true"
		>
			<path d="M2 8h34v18H2z" stroke="#8A8F9E" strokeWidth="1.2" fill="#fff" />
			<path d="M2 8l6-6h34l-6 6M36 26l6-6V2" stroke="#8A8F9E" strokeWidth="1.2" fill="#F7F8FA" />
			<path d="M19 8v18" stroke="#8A8F9E" strokeWidth="1.2" />
		</svg>
	)
}
